export default function SkipNavigationLink() {
    return <a href="#">Skip To Main Content</a>
}
